/**
 * Library
 */
import { createReducer, Reducer } from '@reduxjs/toolkit';

import { libraryNotificationInit } from 'redux/reducers/init';

/**
 * Actions
 */
import { addWaitingLibraryJobId, deleteWaitingLibraryJobId } from 'redux/actions/actions';
/**
 * Action Types
 */
import { AddWatingLibraryJobIdAction, DeleteWatingLibraryJobIdAction } from 'redux/actions/type';

/**
 * Reducers
 */
const libraryNotification = createReducer(libraryNotificationInit, {
  [addWaitingLibraryJobId.type]: (state, action: AddWatingLibraryJobIdAction) => {
    const { addIdList, userId } = action.payload;
    state.waitingIdList[userId] = { ...state.waitingIdList[userId], ...addIdList };
  },
  [deleteWaitingLibraryJobId.type]: (state, action: DeleteWatingLibraryJobIdAction) => {
    const { deleteIdList, userId } = action.payload;
    const idList = Object.keys(deleteIdList);
    idList.forEach(id => {
      delete state.waitingIdList[userId][id];
    });
  },
});

export default libraryNotification;
